<template>
	<c-dialog ref="dialog" title="成交明细" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<module>
			<module-col>
				<div class="m-detail-box">
					<c-table :data="dealList" border :paging="false">
						<c-table-column label="产品信息" min-width="260">
							<template #default="{data}">
								<c-state v-if="data.level_type" tag dict="LEVEL_TYPE" :value="data.level_type"></c-state>
								<span>{{data.product_info || '-'}}</span>
							</template>
						</c-table-column>
						<c-table-column label="背贴码" width="140">
							<template #default="{data}">{{data.produce_unique_code || '-'}}</template>
						</c-table-column>
						<c-table-column label="IMEI" width="150">
							<template #default="{data}">{{data.produce_imei || '-'}}</template>
						</c-table-column>
						<c-table-column label="成交价" width="100">
							<template #default="{data}">
								<span style="color: #e53e3e;">{{formatPrice(data.deal_price)}}</span>
							</template>
						</c-table-column>
						<c-table-column label="销售渠道" width="130">
							<template #default="{data}">{{data.win_channel_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="订单号" width="180">
							<template #default="{data}">{{data.order_no || '-'}}</template>
						</c-table-column>
						<c-table-column label="订单状态" width="90">
							<template #default="{data}">{{data.order_state_name || '-'}}</template>
						</c-table-column>
						<c-table-column label="收货信息" min-width="220">
							<template #default="{data}">{{data.receiver_info || '-'}}</template>
						</c-table-column>
						<c-table-column label="成交时间" width="160">
							<template #default="{data}">{{data.deal_time || '-'}}</template>
						</c-table-column>
					</c-table>
				</div>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'auctionDealDetail',

		data() {
			return {
				auctionBatchNo: '',
				dealList: []
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.auctionBatchNo = data.auction_batch_no;
				this.dealList = [];
				this.$refs.dialog.open();
				this.loadDetail();
			},

			/*********加载场次成交明细（单场次量级有限，一次性拉取）**********/
			loadDetail() {
				this.request({
					url: '/sale/auction/report/stat/deal/list',
					data: {
						auction_batch_no: this.auctionBatchNo,
						page_no: 1,
						page_size: 1000
					},
					loading: true,
					success: data => {
						this.dealList = data || [];
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-box {
		padding: 10px;
	}
</style>
